<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import { AdWrapper } from '@toni/brand-ui'

import { useAd } from '../../../advertisement/composables/use-ad'
import { useIntersectionObserver } from '../../../composables/use-intersection-observer'

const props = defineProps<{
  index: number;
}>()

const adWrapperRef = ref<InstanceType<typeof AdWrapper> | null>(null)

const index = computed(() => props.index)
const { slotName, status, minWidth, minHeight } = useAd('banner', index.value)

const { isIntersecting } = useIntersectionObserver(() => adWrapperRef.value?.divRef)

const forceMount = ref(false)
onMounted(() => {
  setTimeout(() => {
    const isVisible = isIntersecting.value
    forceMount.value = isVisible
  }, 0)
})

</script>

<template>
  <AdWrapper v-if="forceMount || (slotName && status !== 'failed')"
             ref="adWrapperRef"
             :min-width="minWidth"
             :min-height="minHeight"
             :slot-name="slotName">
    <div :id="slotName"
         class="MoltenBundle" />
  </AdWrapper>
</template>
